import React from 'react';
import { Presentation } from './components/Presentation';
export function App() {
  return <div className="min-h-screen bg-black text-slate-50" data-id="element-0">
      <Presentation data-id="element-1" />
    </div>;
}